import { useState} from 'react'
import { Dialog, DialogContent } from "@mui/material";
import { IoClose } from "react-icons/io5";


type Props = {
    performance: boolean;
    setPerformance: (value: boolean) => void;
    // id: string;
  };

export default function PerformanceModal({ performance, setPerformance }: Props) {

  return (
    <Dialog open={performance}>
      <DialogContent style={{ paddingBottom: "0" }}>
        <div className='flex justify-between items-center p-5'>
          <div>
            <p className='items-center text-[24px] leading-[28.8px]'>Select Department</p>
          </div>
          <div className='flex justify-center items-center w-[50px] h-[50px] bg-[#FFDBDB] rounded-[50px]'>
            <IoClose size={25} />
          </div>
        </div>

        <div>
          {Cards.map((card: any, index: any) => {
            return (
              <div key={index}>
                <div>{card.icon}</div>
                <div>{card.title}</div>
              </div>
            )
          })}
        </div>
      </DialogContent>
    </Dialog>
  )
}

const Cards = [
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  },
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  },
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  },
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  },
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  },
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  },
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  },
  {
    icons: <IoClose size={25} />,
    title: "Operations"
  }
]
